export const DEF_CONST = {
  csrfKey: 'csrf',
  csrfPos: {
    params: 'params',
    headers: 'headers'
  },
  timeout: 10000,
  timeoutNode: 350,
  contentType: {
    KEY: 'Content-Type',
    GET: 'application/json',
    JSON: 'application/json',
    POST: 'application/x-www-form-urlencoded',
    FILE: 'multipart/form-data'
  },
  method: {
    GET: 'GET',
    POST: 'POST',
    UPLOAD: 'UPLOAD'
  },
  api: {
    nav: '//api.bilibili.com/x/web-interface/nav',
    identify: 'http://api.bilibili.co/x/internal/identify/cookie'
  }
}

// https://info.bilibili.co/pages/viewpage.action?pageId=122256874
export const BRIDGE_METHOD = {
  request: 'net.request',
  requestV2: 'net.requestV2',
  requestWithSign: 'net.requestWithSign',
  requestWithSignV2: 'net.requestWithSignV2',
  getCsrf: 'net.getCsrf',
  uploadImage: 'net.uploadImage',
  uploadImageV2: 'net.uploadImageV2'
}

export const AUTH_METHOD = {
  web: 'web',
  app: 'mobile',
  all: 'auto'
}
